import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";

import { Box, Typography } from "@mui/material";
import EasyAnchorLink from "../../UI/AnchorLink";

import { GridColDef } from "@mui/x-data-grid-premium";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";

import "../BrandMetadataReview.css";

interface NonOmniReviewProps {
  chain_id: string;
  country_code: string;
}

const ReviewPlacesParentLocation: React.FC<NonOmniReviewProps> = ({
  chain_id,
  country_code,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);

  const { showError } = useError();
  const { apiRequest } = useApi();

  const columns_def: GridColDef[] = [
    {
      field: "place_id",
      headerName: "Place ID",
      description: "The unique identifier for the place.",
      type: "string",
      width: 200,
    },
    {
      field: "name",
      headerName: "Place Name",
      description: "The name of the place.",
      type: "string",
      width: 250,
    },
    {
      field: "chain_id",
      headerName: "Chain ID",
      description:
        "The unique alphanumeric chain_id associated with the brand.",
      type: "string",
      width: 200,
    },
    {
      field: "country_code",
      headerName: "Country Code",
      description: "The country code for the associated place.",
      type: "string",
      width: 150,
    },
    {
      field: "location_parent_id",
      headerName: "Location Parent ID",
      description:
        "The parent location ID, which is equal to the `place_id` in this case.",
      type: "string",
      width: 200,
    },
  ];

  useEffect(() => {
    if (chain_id && country_code) {
      setLoading(true);
      const params = new URLSearchParams({
        chain_id: chain_id,
        country_code: country_code,
      });
      const fetchParentLocation = async () => {
        try {
          const response = await apiRequest<any>(
            `/brand_metadata/equal_parent_location?${params.toString()}`,
            {
              method: "GET",
            }
          );
          if (response.data) {
            setData(response.data);
          }
        } catch (error) {
          console.error(error);
          showError(
            `Failed to fetch places parent locations to review for chain_id ${chain_id} + ${country_code}.`
          );
        } finally {
          setLoading(false);
        }
      };
      fetchParentLocation();
    } else {
      setData([]);
    }
  }, [chain_id, country_code]);

  return (
    <Box className="metadata-review-container">
      <Box display="flex" alignItems="center" id="parent-locations">
        <EasyAnchorLink id="parent-locations" />
        <Typography variant="h6" gutterBottom sx={{ fontSize: "1.25rem" }}>
          Check for places where ID equals the location_parent_id
        </Typography>
      </Box>

      <GaneshDataGrid
        gridId="placesReviewLocationParent"
        columns={columns_def}
        data={data}
        loading={loading}
        headerFilters={data.length > 0 ? true : false}
        customHeight={data.length > 0 ? "750px" : "300px"}
      />
    </Box>
  );
};

export default ReviewPlacesParentLocation;
